import { Link } from '@tanstack/react-router'

/**
 * Satu baris kelas atau jasa: gambar kecil, judul, keterangan, harga.
 *
 * Dipakai di pencarian dan di tab profil, tempat daftar dibaca cepat dari
 * atas ke bawah. Kartu besar katalog terlalu makan tempat di kolom sempit.
 */
export function BarisProduk({
  ke,
  slug,
  gambar,
  judul,
  keterangan,
  harga,
}: {
  ke: '/kelas/$slug' | '/jasa/$slug'
  slug: string
  gambar: string
  judul: string
  keterangan: string
  harga: string
}) {
  return (
    <li className="border-b border-line">
      <Link to={ke} params={{ slug }} className="flex items-center gap-3 py-3 transition hover:opacity-80">
        <div className="size-14 shrink-0 overflow-hidden rounded-xl border border-line bg-sunken">
          {gambar ? <img src={gambar} alt="" loading="lazy" className="size-full object-cover" /> : null}
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate font-semibold text-ink">{judul}</p>
          <p className="truncate text-sm text-muted">{keterangan}</p>
        </div>
        <span className="shrink-0 text-sm font-bold text-ink">{harga}</span>
      </Link>
    </li>
  )
}
